var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
import { classNames } from '@progress/kendo-react-common';
import { UploadFileStatus } from './interfaces/UploadFileStatus';
import { UploadListSingleItem } from './UploadListSingleItem';
import { UploadListMultiItem } from './UploadListMultiItem';
import utils from './utils/utils';
/**
 * @hidden
 */
var UploadListGroup = /** @class */ (function (_super) {
    __extends(UploadListGroup, _super);
    function UploadListGroup() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._element = null;
        _this.onClick = function () {
            _this.props.onClick.call(undefined, _this.props.index);
        };
        return _this;
    }
    UploadListGroup.prototype.componentDidUpdate = function () {
        var _a = this.props, navigationIndex = _a.navigationIndex, index = _a.index;
        if (navigationIndex === index &&
            this._element &&
            document.activeElement !== this._element) {
            this._element.focus();
        }
    };
    UploadListGroup.prototype.render = function () {
        var _this = this;
        var _a = this.props, files = _a.files, async = _a.async, disabled = _a.disabled, navigationIndex = _a.navigationIndex, index = _a.index, listItemUI = _a.listItemUI, onCancel = _a.onCancel, onRemove = _a.onRemove, onRetry = _a.onRetry;
        var firstFile = files[0];
        var isFileSuccess = firstFile.status === UploadFileStatus.Uploaded ||
            firstFile.status === UploadFileStatus.Initial;
        var liClassName = classNames('k-file', utils.filesHaveValidationErrors(files) ? 'k-file-error k-file-invalid' : '', firstFile.status === UploadFileStatus.UploadFailed || firstFile.status === UploadFileStatus.RemoveFailed ?
            'k-file-error' : '', firstFile.status === UploadFileStatus.Uploading ? 'k-file-progress' : '', isFileSuccess ? 'k-file-success' : '', navigationIndex === index ? 'k-focus' : '');
        var itemOptions = {
            async: async,
            disabled: disabled,
            onCancel: onCancel,
            onRemove: onRemove,
            onRetry: onRetry
        };
        var ItemComponent = listItemUI || (files.length === 1 ? UploadListSingleItem : UploadListMultiItem);
        return (React.createElement("li", { ref: function (ref) { return _this._element = ref; }, className: liClassName, "data-uid": firstFile.uid, tabIndex: -1, onClick: this.onClick },
            React.createElement(ItemComponent, __assign({ files: files }, itemOptions))));
    };
    return UploadListGroup;
}(React.Component));
export { UploadListGroup };
